export const GET_THEME = 'GET_THEME'
